module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/kea/~/babel-runtime/core-js/object/assign.js
// module id = 97
// module chunks = 2